export const practiceAreas = [
  {
    slug: 'corporate-ma',
    title: 'Corporate & M&A',
    shortTitle: 'Corporate',
    icon: 'M&A',
    summary: 'Complex cross-border transactions, governance, private equity, and strategic corporate advisory.',
    description:
      'We advise boards, founders, investors, and global enterprises through high-value transactions and long-horizon corporate decisions. Our work combines deal execution, governance judgement, tax-aware structuring, and coordinated local counsel management.',
    specialties: ['Private Equity', 'Public M&A', 'Joint Ventures'],
    services: [
      'Public and private mergers and acquisitions',
      'Private equity investments and exits',
      'Board governance and shareholder advisory',
      'Joint ventures, alliances, and carve-outs',
      'Corporate reorganizations and integrations'
    ],
    matters: [
      'Coordinating multi-jurisdiction acquisitions with antitrust and employment workstreams.',
      'Advising growth companies on investor rights, governance, and strategic partnerships.',
      'Structuring cross-border carve-outs for regulated international groups.'
    ],
    stats: [
      { value: '500+', label: 'Transactions advised' },
      { value: '45+', label: 'Jurisdictions coordinated' },
      { value: '$120B+', label: 'Aggregate deal value' }
    ],
    contact: 'nicolasmachris@kingsbridgellp.com'
  },
  {
    slug: 'banking-finance',
    title: 'Banking & Finance',
    shortTitle: 'Finance',
    icon: 'FIN',
    summary: 'Sophisticated financing solutions across capital markets, structured finance, and major projects.',
    description:
      'Our finance team supports lenders, sponsors, arrangers, and borrowers on ambitious financings. We bring practical execution discipline to credit, capital markets, restructuring, and project finance mandates.',
    specialties: ['Debt Capital Markets', 'Structured Finance', 'Project Finance'],
    services: [
      'Acquisition and leveraged finance',
      'Debt capital markets and private placements',
      'Structured products and securitization',
      'Project and infrastructure finance',
      'Restructuring, refinancing, and covenant advisory'
    ],
    matters: [
      'Advising lenders on a multi-currency facilities package for an infrastructure acquisition.',
      'Supporting an issuer on private placement documentation and investor diligence.',
      'Coordinating finance, real estate, and regulatory teams on a portfolio refinancing.'
    ],
    stats: [
      { value: '$90B+', label: 'Financings supported' },
      { value: '80+', label: 'Institutional lenders' },
      { value: '24/7', label: 'Cross-zone execution' }
    ],
    contact: 'finance@kingsbridgellp.com'
  },
  {
    slug: 'litigation-disputes',
    title: 'Litigation & Dispute Resolution',
    shortTitle: 'Litigation',
    icon: 'LIT',
    summary: 'Strategic litigation, arbitration, investigations, and dispute resolution for high-stakes matters.',
    description:
      'We represent clients in commercial disputes where reputation, capital, and business continuity are on the line. Our disputes lawyers design efficient strategies for courts, arbitration forums, regulators, and negotiated resolutions.',
    specialties: ['International Arbitration', 'White Collar', 'Regulatory'],
    services: [
      'Commercial litigation and injunctive relief',
      'International arbitration and enforcement',
      'Internal investigations and white collar defense',
      'Regulatory disputes and crisis response',
      'Settlement strategy and dispute avoidance'
    ],
    matters: [
      'Defending a multinational group in parallel arbitration and regulatory proceedings.',
      'Leading a privileged internal investigation across several business units.',
      'Securing urgent relief in a contested shareholder and governance dispute.'
    ],
    stats: [
      { value: '35+', label: 'Arbitration forums' },
      { value: '150+', label: 'High-value disputes' },
      { value: '6', label: 'Core disputes hubs' }
    ],
    contact: 'disputes@kingsbridgellp.com'
  },
  {
    slug: 'technology-innovation',
    title: 'Technology & Innovation',
    shortTitle: 'Technology',
    icon: 'TEC',
    summary: 'Legal support for digital transformation, AI, fintech, cybersecurity, and data-driven business models.',
    description:
      'We help clients commercialize, govern, and defend technology. Our team works across product counsel, platform regulation, privacy, cybersecurity, AI governance, and technology transactions.',
    specialties: ['Fintech', 'Cybersecurity', 'Data Privacy'],
    services: [
      'Technology transactions and outsourcing',
      'AI governance and model risk frameworks',
      'Privacy, data protection, and cybersecurity',
      'Fintech, digital assets, and payments',
      'IP commercialization and platform terms'
    ],
    matters: [
      'Designing an AI governance framework for a regulated financial services group.',
      'Negotiating global SaaS, cloud, and outsourcing agreements for a technology platform.',
      'Supporting incident response and regulator communications after a cyber event.'
    ],
    stats: [
      { value: '300+', label: 'Technology matters' },
      { value: '40+', label: 'Privacy regimes mapped' },
      { value: '12', label: 'Product counsel teams' }
    ],
    contact: 'technology@kingsbridgellp.com'
  },
  {
    slug: 'regulatory-compliance',
    title: 'Regulatory & Compliance',
    shortTitle: 'Regulatory',
    icon: 'REG',
    summary: 'Risk, governance, investigations, ESG, antitrust, and financial regulation across major markets.',
    description:
      'Our regulatory practice helps organizations anticipate change, build defensible compliance programs, and respond to supervisory scrutiny. We translate complex rulebooks into board-ready strategy and operational steps.',
    specialties: ['ESG', 'Antitrust', 'Financial Regulation'],
    services: [
      'Financial services regulation',
      'Antitrust and competition compliance',
      'ESG reporting and supply chain governance',
      'Regulatory investigations and remediation',
      'Policies, controls, and board reporting'
    ],
    matters: [
      'Preparing a financial institution for a supervisory review across three regulators.',
      'Building antitrust training and approval processes for a global sales organization.',
      'Mapping ESG reporting obligations for a multinational supply chain.'
    ],
    stats: [
      { value: '60+', label: 'Regulators engaged' },
      { value: '200+', label: 'Compliance projects' },
      { value: '4', label: 'Core risk disciplines' }
    ],
    contact: 'regulatory@kingsbridgellp.com'
  },
  {
    slug: 'real-estate',
    title: 'Real Estate',
    shortTitle: 'Real Estate',
    icon: 'RE',
    summary: 'Development, investment, leasing, financing, and disputes for major real estate assets worldwide.',
    description:
      'We advise investors, developers, funds, occupiers, and lenders on real estate strategy from acquisition through exit. Our team connects property law with finance, planning, tax, and operational risk.',
    specialties: ['Development', 'Investment', 'REIT Advisory'],
    services: [
      'Acquisitions, disposals, and portfolio sales',
      'Development and planning strategy',
      'Real estate finance and joint ventures',
      'Leasing and asset management',
      'REITs, funds, and platform investments'
    ],
    matters: [
      'Advising on a cross-border logistics portfolio acquisition and financing.',
      'Structuring a mixed-use development joint venture with public-sector stakeholders.',
      'Managing leasing and operational diligence for a hospitality platform.'
    ],
    stats: [
      { value: '$35B+', label: 'Real estate assets' },
      { value: '120+', label: 'Major properties' },
      { value: '18', label: 'Markets covered' }
    ],
    contact: 'realestate@kingsbridgellp.com'
  }
];

export const sectors = [
  {
    slug: 'financial-services',
    title: 'Financial Services',
    icon: 'FS',
    metric: '500+ Deals',
    summary: 'Banking, insurance, asset management, payments, capital markets, and fintech.',
    description:
      'We support financial institutions, challengers, market infrastructure providers, and investors across transactions, regulation, disputes, and technology transformation.',
    capabilities: [
      'Banking and capital markets transactions',
      'Payment services, fintech, and digital assets',
      'Regulatory change, remediation, and governance',
      'Financial institution disputes and investigations'
    ],
    trends: ['AI in financial controls', 'Private credit expansion', 'Operational resilience']
  },
  {
    slug: 'energy-infrastructure',
    title: 'Energy & Infrastructure',
    icon: 'EN',
    metric: '$200B+ Projects',
    summary: 'Renewable energy, conventional energy, transport, telecoms, and social infrastructure.',
    description:
      'Our lawyers advise sponsors, governments, lenders, and contractors on projects that move capital and public services across borders.',
    capabilities: [
      'Project development and financing',
      'Public-private partnerships',
      'Construction, concessions, and procurement',
      'Energy transition and grid modernization'
    ],
    trends: ['Battery storage scale-up', 'Grid investment', 'Public-private capital models']
  },
  {
    slug: 'technology-media',
    title: 'Technology & Media',
    icon: 'TM',
    metric: '300+ Transactions',
    summary: 'Software, platforms, media, content, telecoms, cybersecurity, and data-rich businesses.',
    description:
      'We help technology and media companies navigate fast product cycles, regulatory pressure, content risk, and growth transactions.',
    capabilities: [
      'Product counsel and platform regulation',
      'Technology M&A and venture investments',
      'Content rights and commercial partnerships',
      'Cybersecurity and privacy response'
    ],
    trends: ['AI accountability', 'Platform safety rules', 'Data localization']
  },
  {
    slug: 'healthcare-life-sciences',
    title: 'Healthcare & Life Sciences',
    icon: 'HL',
    metric: '150+ M&A Deals',
    summary: 'Pharmaceuticals, biotech, medical devices, hospitals, diagnostics, and digital health.',
    description:
      'We advise healthcare and life sciences clients on regulation, transactions, intellectual property, privacy, and collaborations.',
    capabilities: [
      'Licensing, collaborations, and commercialization',
      'Healthcare M&A and investment',
      'Regulatory and reimbursement strategy',
      'Clinical data, privacy, and compliance'
    ],
    trends: ['AI-enabled diagnostics', 'Global trial complexity', 'Data governance']
  }
];

export const insights = [
  {
    slug: 'global-ma-trends-2026',
    category: 'Market Analysis',
    title: 'Global M&A Trends: Navigating 2026',
    date: 'January 8, 2026',
    readTime: '5 min read',
    icon: 'M&A',
    excerpt:
      'An analysis of emerging patterns in cross-border transactions, financing pressure, and market consolidation.',
    author: 'Corporate Insights Team',
    body: [
      'Dealmakers are approaching 2026 with a sharper focus on certainty, integration, and regulatory timing. Strategic buyers continue to prioritize assets that improve resilience, platform scale, or technology capability.',
      'The strongest transactions are being planned with regulatory, financing, employment, tax, and communications workstreams aligned from the outset. That coordination is increasingly the difference between a signed deal and a closed deal.',
      'Boards should pressure-test valuation, downside scenarios, and stakeholder messaging early, especially where the transaction spans multiple regulators or sensitive data sets.'
    ]
  },
  {
    slug: 'ai-governance-new-framework',
    category: 'Regulatory Update',
    title: 'AI Governance: Building a Board-Ready Framework',
    date: 'January 5, 2026',
    readTime: '7 min read',
    icon: 'AI',
    excerpt:
      'Practical steps for governing artificial intelligence, model risk, data protection, and accountability.',
    author: 'Technology & Regulatory Teams',
    body: [
      'AI governance is moving from policy language to operational proof. Organizations need clear ownership, documented risk tiers, vendor oversight, and repeatable review processes.',
      'A strong framework connects legal requirements with the actual product lifecycle: intake, development, testing, deployment, monitoring, and retirement.',
      'The highest-value programs are designed for evidence. They can show who approved a use case, what controls applied, and how performance or harm indicators are monitored.'
    ]
  },
  {
    slug: 'esg-compliance-2026',
    category: 'Sustainability',
    title: 'ESG Compliance in 2026',
    date: 'December 28, 2025',
    readTime: '6 min read',
    icon: 'ESG',
    excerpt:
      'Strategic approaches to environmental, social, and governance requirements across global supply chains.',
    author: 'Regulatory & Compliance Team',
    body: [
      'ESG compliance now requires stronger evidence across governance, supplier oversight, climate reporting, and claims review. The risk is no longer limited to annual disclosure.',
      'Organizations should map obligations by market, assign executive ownership, and ensure that public statements are matched by internal controls.',
      'The most durable programs combine legal interpretation with procurement, finance, operations, and communications discipline.'
    ]
  },
  {
    slug: 'private-credit-infrastructure',
    category: 'Finance',
    title: 'Private Credit and Infrastructure: New Capital Pathways',
    date: 'December 12, 2025',
    readTime: '8 min read',
    icon: 'FIN',
    excerpt:
      'How private credit is reshaping infrastructure financing, lender dynamics, and risk allocation.',
    author: 'Banking & Finance Team',
    body: [
      'Private credit is becoming a central funding source for infrastructure sponsors seeking speed, flexibility, and scale. The shift changes negotiation dynamics across covenants, security, and intercreditor arrangements.',
      'Sponsors should compare headline pricing with draw mechanics, consent rights, future capital flexibility, and refinancing optionality.',
      'Successful financings bring legal, technical, financial, and regulatory diligence together early enough to avoid late-stage covenant friction.'
    ]
  },
  {
    slug: 'cyber-incident-board-response',
    category: 'Cybersecurity',
    title: 'Cyber Incident Response: What Boards Need in the First 72 Hours',
    date: 'November 21, 2025',
    readTime: '6 min read',
    icon: 'CYB',
    excerpt:
      'A focused board checklist for privilege, notification, operational continuity, and stakeholder messaging.',
    author: 'Technology & Disputes Teams',
    body: [
      'The first 72 hours of a cyber incident are defined by information gaps. Boards need disciplined escalation, privilege protocols, and a clear record of decisions made under uncertainty.',
      'Legal, security, communications, insurance, and business continuity teams should operate from a single response structure.',
      'The strongest response plans are rehearsed before an incident and updated after each tabletop exercise or real-world event.'
    ]
  }
];

export const offices = [
  {
    slug: 'london',
    city: 'London',
    country: 'United Kingdom',
    region: 'EMEA',
    address: '24 King William Street, London EC4R 9AT',
    phone: '+44 7490 947238',
    email: 'london@kingsbridgellp.com',
    description:
      'Our London office anchors the firm across corporate, finance, disputes, technology, and regulatory work throughout Europe.',
    highlights: ['Corporate and M&A', 'Banking and finance', 'International arbitration', 'Technology regulation']
  },
  {
    slug: 'new-york',
    city: 'New York',
    country: 'United States',
    region: 'Americas',
    address: '1251 Avenue of the Americas, New York, NY 10020',
    phone: '+1 212 878 8000',
    email: 'newyork@kingsbridgellp.com',
    description:
      'New York supports financial institutions, investors, and multinational clients across transactions, disputes, and regulatory matters.',
    highlights: ['Capital markets', 'Private equity', 'Financial regulation', 'Commercial litigation']
  },
  {
    slug: 'hong-kong',
    city: 'Hong Kong',
    country: 'Hong Kong SAR',
    region: 'Asia Pacific',
    address: 'Central Plaza, 18 Harbour Road, Wan Chai',
    phone: '+852 2846 8888',
    email: 'hongkong@kingsbridgellp.com',
    description:
      'Hong Kong connects clients to capital, technology, and cross-border investment activity across Asia Pacific.',
    highlights: ['Cross-border M&A', 'Funds', 'Technology transactions', 'Regional disputes']
  },
  {
    slug: 'dubai',
    city: 'Dubai',
    country: 'United Arab Emirates',
    region: 'EMEA',
    address: 'Gate Village, DIFC, Dubai',
    phone: '+971 4 503 2600',
    email: 'dubai@kingsbridgellp.com',
    description:
      'Dubai is a regional hub for infrastructure, energy, real estate, finance, and international arbitration.',
    highlights: ['Infrastructure', 'Energy', 'Real estate', 'Arbitration']
  },
  {
    slug: 'singapore',
    city: 'Singapore',
    country: 'Singapore',
    region: 'Asia Pacific',
    address: 'One Raffles Quay, North Tower',
    phone: '+65 6538 9888',
    email: 'singapore@kingsbridgellp.com',
    description:
      'Singapore supports clients on Southeast Asia transactions, projects, private capital, and technology growth.',
    highlights: ['Projects', 'Private capital', 'Fintech', 'Data protection']
  },
  {
    slug: 'paris',
    city: 'Paris',
    country: 'France',
    region: 'EMEA',
    address: '8 Avenue Hoche, 75008 Paris',
    phone: '+33 1 44 94 40 00',
    email: 'paris@kingsbridgellp.com',
    description:
      'Paris advises clients across European transactions, competition matters, employment, real estate, and disputes.',
    highlights: ['Competition', 'Corporate', 'Employment', 'Real estate']
  }
];

export const careers = [
  {
    slug: 'corporate-associate-london',
    title: 'Corporate Associate',
    location: 'London',
    team: 'Corporate & M&A',
    type: 'Full time',
    summary:
      'Join a cross-border corporate team advising public companies, private equity sponsors, and growth businesses.',
    requirements: ['3-5 years of corporate experience', 'Strong drafting discipline', 'Cross-border deal exposure']
  },
  {
    slug: 'finance-counsel-new-york',
    title: 'Finance Counsel',
    location: 'New York',
    team: 'Banking & Finance',
    type: 'Full time',
    summary:
      'Lead financing workstreams for lenders, sponsors, and borrowers across acquisition and structured finance.',
    requirements: ['7+ years of finance experience', 'Client leadership skills', 'Capital markets familiarity']
  },
  {
    slug: 'technology-regulatory-lawyer-singapore',
    title: 'Technology Regulatory Lawyer',
    location: 'Singapore',
    team: 'Technology & Innovation',
    type: 'Full time',
    summary:
      'Advise platform, fintech, and data-driven clients on product regulation, privacy, cybersecurity, and AI governance.',
    requirements: ['4+ years in technology regulation', 'Privacy or cybersecurity background', 'Commercial judgement']
  },
  {
    slug: 'legal-operations-analyst',
    title: 'Legal Operations Analyst',
    location: 'Remote / Hybrid',
    team: 'Innovation',
    type: 'Full time',
    summary:
      'Support matter delivery, knowledge systems, reporting, and process improvement across the global firm.',
    requirements: ['Data and workflow fluency', 'Excellent stakeholder communication', 'Legal sector experience preferred']
  }
];

export const resources = {
  publications: [
    {
      title: 'Cross-Border Deal Readiness Guide',
      category: 'Guide',
      date: 'February 2026',
      summary: 'A practical checklist for diligence, approvals, employment, tax, and closing mechanics.'
    },
    {
      title: 'Global AI Governance Tracker',
      category: 'Reference',
      date: 'January 2026',
      summary: 'A jurisdiction-by-jurisdiction overview of AI governance themes and operating controls.'
    },
    {
      title: 'Infrastructure Finance Terms Briefing',
      category: 'Briefing',
      date: 'December 2025',
      summary: 'Current trends in covenants, security, direct agreements, and refinancing flexibility.'
    }
  ],
  events: [
    {
      title: 'Boardroom Briefing: AI Risk and Accountability',
      category: 'Webinar',
      date: 'March 18, 2026',
      summary: 'A private session for directors and executives on practical AI governance.'
    },
    {
      title: 'Private Capital Forum',
      category: 'Roundtable',
      date: 'April 9, 2026',
      summary: 'A closed-door discussion on private credit, infrastructure, and platform transactions.'
    },
    {
      title: 'Cyber Response Tabletop',
      category: 'Workshop',
      date: 'May 14, 2026',
      summary: 'A guided simulation for legal, security, communications, and executive teams.'
    }
  ],
  news: [
    {
      title: 'Kings Bridge LLP Expands Technology Practice',
      category: 'Firm News',
      date: 'January 22, 2026',
      summary: 'The firm has added senior technology and privacy capability across London and Singapore.'
    },
    {
      title: 'Infrastructure Team Advises on Renewable Energy Portfolio',
      category: 'Deal News',
      date: 'January 12, 2026',
      summary: 'The cross-border team supported financing and regulatory workstreams for a major portfolio.'
    },
    {
      title: 'Firm Recognized for Cross-Border Client Service',
      category: 'Recognition',
      date: 'December 16, 2025',
      summary: 'Kings Bridge LLP was recognized for coordinated delivery across key global offices.'
    }
  ]
};

export const firmStats = [
  { value: '31', label: 'Offices worldwide' },
  { value: '3,000+', label: 'Legal professionals' },
  { value: '150+', label: 'Years of combined leadership experience' },
  { value: '45+', label: 'Jurisdictions coordinated each year' }
];

export const values = [
  {
    title: 'Client Clarity',
    text: 'We translate complexity into decisions, timelines, and risk choices that executives can act on.'
  },
  {
    title: 'Global Coordination',
    text: 'Our teams work across offices and disciplines so clients receive one connected answer.'
  },
  {
    title: 'Commercial Courage',
    text: 'We give direct advice, test assumptions, and focus on outcomes that matter to the business.'
  },
  {
    title: 'Responsible Innovation',
    text: 'We use technology and process discipline to improve quality, speed, and transparency.'
  }
];

export const legalPages = {
  privacy: {
    title: 'Privacy Policy',
    updated: 'Updated January 2026',
    sections: [
      {
        heading: 'Information We Collect',
        text: 'We collect information provided through contact forms, newsletter subscriptions, event registrations, and direct communications with the firm.'
      },
      {
        heading: 'How We Use Information',
        text: 'We use information to respond to inquiries, provide requested materials, manage client relationships, operate the website, and meet professional obligations.'
      },
      {
        heading: 'Your Choices',
        text: 'You may request access, correction, or deletion of personal information where applicable by contacting privacy@kingsbridgellp.com.'
      }
    ]
  },
  terms: {
    title: 'Terms of Use',
    updated: 'Updated January 2026',
    sections: [
      {
        heading: 'Website Content',
        text: 'This website is provided for general information only. It does not create a lawyer-client relationship or constitute legal advice.'
      },
      {
        heading: 'No Warranty',
        text: 'Although we aim to keep content current, the website is provided as available and without warranties of completeness or fitness for a particular purpose.'
      },
      {
        heading: 'Professional Engagements',
        text: 'Any legal engagement is subject to conflict checks, written terms, and applicable professional rules.'
      }
    ]
  },
  cookies: {
    title: 'Cookie Policy',
    updated: 'Updated January 2026',
    sections: [
      {
        heading: 'Cookie Use',
        text: 'The website may use cookies and similar technologies to support basic functionality, analytics, and preferences.'
      },
      {
        heading: 'Managing Cookies',
        text: 'Most browsers allow you to block or delete cookies. Some website features may not function as expected if cookies are disabled.'
      },
      {
        heading: 'Analytics',
        text: 'Where analytics tools are used, they help us understand aggregate site performance and improve content relevance.'
      }
    ]
  },
  accessibility: {
    title: 'Accessibility',
    updated: 'Updated January 2026',
    sections: [
      {
        heading: 'Our Commitment',
        text: 'Kings Bridge LLP aims to provide a website that is accessible, readable, and usable for a broad range of visitors.'
      },
      {
        heading: 'Ongoing Review',
        text: 'We review structure, contrast, keyboard access, and content clarity as part of ongoing site maintenance.'
      },
      {
        heading: 'Feedback',
        text: 'If you experience an accessibility barrier, contact accessibility@kingsbridgellp.com with the page address and a description of the issue.'
      }
    ]
  }
};

export const diversityCommitments = [
  'Build leadership pipelines that widen opportunity across offices and practice groups.',
  'Use transparent progression criteria and structured feedback for every lawyer and business professional.',
  'Support flexible work, wellbeing, sponsorship, and inclusive client teams.',
  'Track representation, retention, and matter leadership so progress is visible and accountable.'
];
